export default "__VITE_ASSET__B_xji4W1__"